import React, { useEffect, useState, useRef } from 'react';
import { ReactComponent as CrossIcon } from '../../../../assets/icons/cross.svg';
import { useTranslation } from 'react-i18next';
import { ReactComponent as DropDownArrowIcon } from '../../../../assets/icons/user-settings-arrow-down.svg';

import { useSettingsState } from '../../../context/SettingsContext';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';
import Combobox from '@/v2/components/Combobox.jsx';
import Select from '@/v2/components/Select.jsx';
import { filter } from 'lodash';
import Switch from '@/v2/components/Switch';
import { useCartData } from '@/v2/pages/CartPage/context/CartDataContext';
function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });
  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return windowSize;
}

const FilterNew = ({
  value,
  onChange,
  isLoading,
  filters,
  onClear,
  category,
  isGrid,
  enableSorting,
  disabledFiltersById,
  shouldFilterBeExpanded = false,
  disableSwitch = false,
}) => {
  const location = useLocation();
  const [userSettingsOpen, setUserSettingsOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const { theme } = useSettingsState();
  const [openOrderingDown, setOpenOrderingDown] = useState(true);
  const { t } = useTranslation();
  const orderingIconRef = useRef();
  const [psdfSwitchFilterEnabled, setPsdfSwitchFilterEnabled] = useState(false);
  const orderingMenuRef = useRef();
  const [filterVisibility, setFilterVisibility] = useState(
    !!location?.search || shouldFilterBeExpanded,
  );
  const [psdfSwitchDisabled, setPsdfSwitchDisabled] = useState(false);
  const firstUpdate = useRef(true);
  const { addingMorePsdfServices } = useCartData();
  function getTypeOptions(type) {
    return filters[type].map((sc) => ({
      label: sc.name,
      value: sc.id + '',
    }));
  }
  const size = useWindowSize();
  useEffect(() => {
    if (userSettingsOpen && filterVisibility) {
      if (
        window.innerHeight -
          orderingIconRef?.current?.getBoundingClientRect()?.bottom -
          orderingMenuRef?.current?.getBoundingClientRect()?.height -
          10 <
        0
      ) {
        setOpenOrderingDown(false);
      } else {
        setOpenOrderingDown(true);
      }
    }
  }, [userSettingsOpen]);

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    setUserSettingsOpen(true);
  }, [openOrderingDown]);

  useEffect(() => {
    if (!filterVisibility && userSettingsOpen) {
      setUserSettingsOpen(false);
    }
  }, [filterVisibility]);

  useEffect(() => {
    if (size.width > 767) {
      setFilterVisibility(true);
    }
  }, [size.width]);

  const filtersMap = Object.keys(filters).reduce((results, filterKey) => {
    const options = getTypeOptions(filterKey);

    if (options.length > 0) {
      results.push({
        label: t(`filters.${filterKey}.label`),
        options: [
          {
            value: '',
            label: t(`filters.${filterKey}.emptyValue`),
          },
          ...options,
        ],
        key: `${filterKey}Id`,
      });
    }

    return results;
  }, []);

  useEffect(() => {
    const val = value['visitPaymentTypeId'];

    if (val === '2' || addingMorePsdfServices) {
      if (addingMorePsdfServices) {
        setPsdfSwitchDisabled(true);
      } else {
        setPsdfSwitchDisabled(false);
      }
      setPsdfSwitchFilterEnabled(true);

      if (value['visitPaymentTypeId'] !== '2') {
        onChange({
          value: '2',
          name: 'visitPaymentTypeId',
        });
      }
    } else {
      setPsdfSwitchDisabled(false);
    }
  }, [filtersMap, addingMorePsdfServices]);

  const closeMenu = () => {
    setOpen(false);
  };

  const userSettingsMenu = () => {
    setUserSettingsOpen(false);
  };

  return (
    <div className="relative bg-[#F9FCFF] pt-4 md:pt-9 z-10 pb-4">
      {Object.keys(filters).length > 0 && (
        <div className="container mx-auto px-4 sm:px-1 md:px-2">
          <div className="text-sm">
            <button
              className="text-[#52585F] text-sm h-5 mb-5 md:hidden"
              onClick={() => setFilterVisibility(!filterVisibility)}
            >
              Filtravimas
              <span className="inline-block pt-1 ml-2">
                <DropDownArrowIcon
                  className={`${
                    filterVisibility ? 'rotate-180' : ''
                  } transition-transform duration-300 w-3 h-3 fill-[#52585F]`}
                />
              </span>
            </button>

            {filterVisibility && (
              <>
                <div className="flex flex-col lg:flex-row md:gap-4 w-full overflow-hidden">
                  {filtersMap.map((filter, i) => {
                    if (filter.key === 'visitPaymentTypeId') return null;

                    return (
                      <div key={i} className="flex-grow min-w-0 mb-3 md:mb-0">
                        <Combobox
                          selected={
                            filter.options.find(
                              (f) => f.value === value[filter.key],
                            ) || filter.options[0]
                          }
                          onChange={(val) =>
                            onChange({ value: val.value, name: filter.key })
                          }
                          options={filter.options.map((c) => ({
                            label: c.label,
                            value: c.value,
                            original: c,
                          }))}
                          placeholder={filter.options[0].label}
                          className="w-full"
                          label={filter.label}
                          allowNullOption={false}
                        />
                      </div>
                    );
                  })}

                  <div className="flex-shrink-0 flex items-center justify-end md:ml-4 mt-1 md:mt-0">
                    <button
                      onClick={onClear}
                      className=" hover:opacity-50 transition"
                    >
                      <CrossIcon className="w-4 h-4 mt-3 fill-[#52585F]" />
                    </button>
                  </div>
                </div>

                <div className="mt-2 flex items-center space-x-2">
                  <Switch
                    enabled={psdfSwitchFilterEnabled}
                    setEnabled={(val) => {
                      if (psdfSwitchDisabled || disableSwitch) return; // prevent toggling when disabled
                      setPsdfSwitchFilterEnabled(val);
                      onChange({
                        value: val ? '2' : null,
                        name: 'visitPaymentTypeId',
                      });
                    }}
                    disabled={psdfSwitchDisabled || disableSwitch} // <-- pass disabled
                  />
                  <span className="text-sm ml-2">
                    Rodyti tik PSDF kompensuojamus laikus
                  </span>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterNew;
